import { makeStyles } from '@material-ui/core'
import { Autorenew, Close, PowerSettingsNew } from '@material-ui/icons'
import React, { useState, useReducer, useEffect } from 'react'
import {
  useMutation,
  useNotify,
  useRecordContext,
  useRefresh,
  useShowContext,
} from 'react-admin'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { Authority } from '../../../../core/auth/Authority'
import { BarrierDto } from '../../../../core/dto/device/barrier/barrier.dto'
import {
  barrierSetPowerButtonInitialState,
  barrierSetPowerButtonReducer,
} from '../../../../core/devices/barriers/barrier-set-power-button.reducer'
import { ToggleType } from '../../../../core/devices/barriers/barrier-set-boolean-status-button'
import { BarrierSelectStateDialog } from '../BarrierDialogs'

const useStyles = makeStyles((theme) => ({
  icon: {
    position: 'absolute',
    left: 5,
    top: 5,
    fontSize: '24px !important',
    color: theme.palette.secondary.light,
  },
  crossIcon: {
    position: 'absolute',
    left: 0,
    top: 0,
    fontSize: 34,
  },
}))

export const BarrierSetPowerButton = ({ ...props }) => {
  const { asRecurringJob, disabled, ...rest } = props
  const notify = useNotify()
  const hasAuthority = useHasAuthority()
  const { loading } = useShowContext()
  const classes = useStyles()

  const [{ mutateQuery }, dispatch] = useReducer(
    barrierSetPowerButtonReducer,
    barrierSetPowerButtonInitialState,
  )
  const [dialogOpen, setDialogOpen] = useState(false)
  const [state, setState] = useState(false)
  const barrier = useRecordContext<BarrierDto>()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const refresh = useRefresh()

  useEffect(() => {
    if (state) {
      dispatch({ type: ToggleType.OFF })
    } else {
      dispatch({ type: ToggleType.ON })
    }
  }, [state])

  const handlePower = async (
    recurringJobName?: string,
    cronExpression?: string,
    auditNote?: string,
  ) => {
    let query
    if (!asRecurringJob) {
      query = mutateQuery?.(barrier, auditNote)
    } else {
      query = mutateQuery?.(
        barrier,
        auditNote,
        recurringJobName as string,
        cronExpression as string,
      )
    }
    await mutate(query, {
      returnPromise: true,
      onFailure: (err) => notify(err?.message, 'error'),
    })
    refresh()
  }

  return (
    <>
      <BarrierSelectStateDialog
        open={dialogOpen}
        confirm={handlePower}
        method="powerState"
        close={() => setDialogOpen(false)}
        state={state}
        setState={setState}
        asRecurringJob={asRecurringJob}
        OnIcon={<PowerSettingsNew className={classes.icon} />}
        OffIcon={
          <>
            <PowerSettingsNew className={classes.icon} />
            <Close fontSize="large" className={classes.crossIcon} />
          </>
        }
        withAuditNote
      />
      <Button
        disabled={
          !hasAuthority(Authority.BARRIERS_SET_POWER_BUTTON) ||
          loading ||
          mutationLoading ||
          disabled === true
        }
        variant="contained"
        color="primary"
        onClick={() => setDialogOpen(true)}
        label={
          !asRecurringJob ? 'resources.barriers.actions.setPowerState' : ''
        }
        useSmallVersionBreakpoint={false}
        {...rest}
      >
        {asRecurringJob ? <Autorenew /> : undefined}
      </Button>
    </>
  )
}
